import React from "react";
import UsersGrid from "../../panels/users/UsersGrid";

export default function RegistersPage() {
    return (
        <UsersGrid/>
    );
}
